import React, { HTMLProps } from 'react'
import { twMerge } from 'tailwind-merge'

interface DownloadNoteProps extends HTMLProps<HTMLDivElement> {
  onClick: () => void
}

const DownloadNote = ({ onClick, className }: DownloadNoteProps) => {
    return (
        <div className={twMerge('text-center mx-auto', className)}>
            <h3 className='pb-12'>Thank you for your interest in the Biomatter!</h3>
            <h3>
                <button className='text-purple' onClick={onClick}>
          Click here
                </button>{' '}
        to download the application note
            </h3>
        </div>
    )
}

export default DownloadNote
